import request from '@/utils/request.js'
import { V3 } from '@/utils/config.js'

export function login(data) {
    return request({
        url: '/'+ V3 +'/auth/login',
        method: 'post',
        data,
        notAlert: true
    })
}

export function logout() {
    return request({
        url: '/'+ V3 +'/auth/logout',
        method: 'post',
    })
}
